import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { KonPermission } from 'app/modules/UIKit/components/kontable/utility/utility-model';
import { StoreGroup } from '../../../../../models/store-common.model';
import { DataTableService } from '../../../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableCustomButton } from '../../../../../modules/UIKit/components/dataTable/dataTableCustomButton.interface';
import { DataTableField } from '../../../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { StoreCommonService } from '../../../../../services/store/store-common.service';

@Component({
  selector: 'app-store-group-details',
  templateUrl: './store-group-details.component.html'
})
export class StoreGroupDetailsComponent implements OnInit {
  @Input() store_group: StoreGroup;
  @Output() onBack: EventEmitter<any> = new EventEmitter<any>();

  titles: DataTableField[];
  customButtons: DataTableCustomButton[];
  showDetail= false;
  perm: KonPermission = new KonPermission();
  modalTitle = '';
  labels = {};
  showStoreSelection = false;

  constructor(
    public svc: StoreCommonService,
    private translate: TranslateService,
    private srvDataTable: DataTableService
  ) {
    this.translate
      .get([
        'common.store_code',
        'common.store_host_code',
        'common.store_name',
        'common.store_short_name',
        'common.store_description',
        'common.store_region',
        'common.store_city',
        'common.back',
        'storeGroupDetail.add_title',
        'storeGroupDetail.edit_title'
      ])
      .subscribe(res => {
        this.titles = [
          { id: 'id', label: '#' },
          { id: 'code', label: res['common.store_code'] },
          { id: 'host_code', label: res['common.store_host_code'] },
          { id: 'name', label: res['common.store_name'] },
          { id: 'short_name', label: res['common.store_short_name'] },
          { id: 'city', label: res['common.store_city'] },
          { id: 'description', label: res['common.store_description'] },
          { id: 'region', label: res['common.store_region'] }
        ];
        this.labels['add_title'] = res['storeGroupDetail.add_title'];
        this.labels['edit_title'] = res['storeGroupDetail.edit_title'];

        this.customButtons = [
          {
            callbackname: 'back',
            isAlwaysEnabled: true,
            label: res['common.back'],
            icon: ''
          }
        ];
      });
  }

  ngOnInit(): void {
    this.reloadList();
    this.perm.edit = false;
    this.perm.view = false;
  }

  onCustomButton(event) {
    this.onBack.emit();
  }

  reloadList() {
    this.svc.getListFilteredByStoreGroup(this.store_group.id).subscribe();
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.svc.editing_store_group_detail =
      data == null ?
        { store_id: null, store_group_id: this.store_group.id} : {
          store_id: data['id'],
          store_group_id: this.store_group.id
        };
    this.showDetail = true;
  }

  delete(event) {
    this.svc.deleteFromGroup(event.id, this.store_group.id).subscribe(() => {
      this.reloadList();
      this.showDetail = false;
    })
  }

  saveDetail(detail) {
    this.svc.postToGroup(detail.store_id, detail.store_group_id).subscribe(() => {
      this.reloadList();
      this.showDetail = false;
      this.srvDataTable.get('dt_stores_group_details').showDetail = false;
    })
  }

  addStore(store) {
    this.svc.postToGroup(store.id, this.store_group.id).subscribe(() => {
      this.reloadList();
      this.showStoreSelection = false;
      this.srvDataTable.get('dt_stores_group_details').showDetail = false;
    })
  }

  onDialogHide () {
    this.svc.editing_store_group_detail = null;
    this.showDetail = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-group/store-group-details/store-group-details.component.ts